<template>
  <v-row justify="center">
    <v-dialog v-model="openImageModal" max-width="600">
      <v-card>
        <div class="d-flex pa-5">
          <div>
            <h2>{{ fileArcheType ? fileArcheType : "File" }}</h2>
          </div>
          <div class="mt-2">
            <!-- <download-image
              :imgSrc="source"
              v-if="checkIfImage(source)"
            ></download-image> -->
          </div>
        </div>

        <div class="text-center">
          <!-- <image-view
            :zoomImg="true"
            :src="source"
            v-if="checkIfImage(source)"
          ></image-view> -->
          <pdf-component
            :src="source"
            :styles="'width: 100%; height: 800px'"
          ></pdf-component>
        </div>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="green darken-1" text @click="close()"> Ok </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>
<script>
const Image = () => import("@/components/image.vue");
const Pdf = () => import("@/components/pdf.vue");
const downloadImage = () => import("@/components/downloadImage.vue");
export default {
  props: ["openImageModal", "source", "fileArcheType"],
  components: {
    "image-view": Image,
    "pdf-component": Pdf,
    downloadImage,
  },
  data() {
    return {};
  },
  methods: {
    close() {
      this.$emit("close");
    },
    checkIfImage(str) {
      if (str.split(".").pop() !== "pdf") return true;
      return false;
    },
  },
};
</script>